export enum VisitationType {
  Enter = 'ENTER',
  Exit = 'EXIT',
}
